import React from 'react';
import { Container, Typography } from 'amphitheatre';
import { AiOutlineTrophy, AiOutlineSmile } from 'react-icons/ai';

import { Trophy } from '../FAQ/FAQ.styled';

import Saber from './_img_saber_logo.png';

const { Header, Paragraph } = Typography;

function Home(): React.ReactElement {
  return (
    <Container className="content-container" size="lg">
      <Header>Results</Header>
      <Paragraph>To our intrepid entrepreneurs,</Paragraph>
      <Paragraph>
        Quest For Blue was a product of us wanting to foster a community of
        space entrepreneurs, what we got was much more. All your entries had the
        hallmarks of innovation and creativity. We truly appreciate the time and
        effort that was put into each and every one of your entries.
      </Paragraph>
      <Paragraph>
        For those who missed out, we’re planning another quest to help put your
        ideas and innovation on the drawing board.
      </Paragraph>
      <Paragraph>
        We’d like to provide some general feedback which we believe will benefit
        everyone and refine their business plans.
        <ul>
          <li>
            TAM is an acronym for Total Addressable Market. We put a lot of
            weight on this because it will predict the viability of your idea
            and therefore the ability to attract investors. The calculations are
            therefore very important in your business proposal. It shows the
            entire potential of your idea.
          </li>
          <ul>
            <li>
              TAM should account for the entirety of the available customers
              your product or service “could sell” to, presuming 100% of the
              market share.
            </li>
            <li>
              A lot of entries had their markets localised to a small familiar
              area, however, a satellite orbits the earth and is able to collect
              usable data the whole round trip. This data can all be downloaded,
              interpreted and sold, limited of course by your data pipeline.
            </li>
            <li>
              TAM should calculate the entire amount of product/service you are
              able to produce during all your overpasses in a 24 hour period.
              Presuming 100% of your products are sold.
            </li>
          </ul>
          <li>
            We had entries selling image products. In our experience of the
            industry as well as through market research, 30m2 per pixel is a
            saturated market with high competition. Ideas in this market would
            need to distinguish itself from the rest either through cost,
            quality or another differentiating factor.
          </li>
        </ul>
      </Paragraph>
      <Paragraph>
        The winners are the entries which reflected the most profitable and
        viable business idea.
      </Paragraph>
      <Paragraph>
        <b>
          Saber Astronautics’ Quest For Blue Competition winners are as follows:
        </b>
      </Paragraph>
      <br />
      <Header>
        <Trophy prize="gold">
          <AiOutlineTrophy />
        </Trophy>
        Gary Stewart of University of Strathclyde (Glasgow, Scotland).
      </Header>
      <Paragraph>
        BlythWeb Constellations mission is a small satellite constellation to
        track the efficiency of the energy grid worldwide, an innovation of two
        rapidly expanding industries.
      </Paragraph>
      <br />
      <Header>
        <Trophy prize="silver">
          <AiOutlineTrophy />
        </Trophy>
        Yan Chen of Melbourne Space Program (Melbourne, Australia).
      </Header>
      <Paragraph>
        Orbitel – Your Ground Station in the Sky is a space based service for
        satellites providing 24/7 spacecraft control and real-time access to
        satellite health and tracking anywhere in Low Earth Orbit.
      </Paragraph>
      <br />
      <Header>
        <Trophy prize="bronze">
          <AiOutlineTrophy />
        </Trophy>
        StrathAIS student team at University of Strathclyde (Glasgow, Scotland).
      </Header>
      <Paragraph>
        Plastic Pollution Identification mission of two satellites to track
        plastic pollution and target environmental support needs worldwide.
      </Paragraph>
      <br />
      <Header>
        <Trophy prize="notable">
          <AiOutlineSmile />
        </Trophy>
        Jackie Deng of University of New South Wales (Sydney, Australia)
      </Header>
      <Paragraph>
        Open Source Satellite mission to allow the general public to access and
        learn to develop satellites using orbital platforms.
      </Paragraph>
      <br />
      <Header>
        <Trophy prize="notable">
          <AiOutlineSmile />
        </Trophy>
        Lisa Scott and Rael Taylor-Sezgin of University of Strathclyde (Glasgow,
        Scotland)
      </Header>
      <Paragraph>
        Chemical Spill and Oil Spill Detection is an oceanic environmental
        satellite constellation tracking the impacts of oil pollution and
        climate change.
      </Paragraph>
      <br />
      <Paragraph>
        Every participant's work showed their commitment and enthusiasm for the
        industry! There were many ideas which can definitely be worked into a
        viable business concept. We consider this a successful first attempt for
        you as participants and for us, Saber Astro as competition hosts. We’d
        like to thank everyone for their entries and efforts. We’re looking
        forward to the next Quest!
      </Paragraph>
      <Paragraph>
        <img src={Saber} alt="signature" height="64px" />
      </Paragraph>
      <Paragraph>Saber Astronautics Team</Paragraph>
    </Container>
  );
}

export default Home;
